<!-- Keep in mind that this is directly in a mat-sidenav, and that sidenav isn't included
in this template because mat-sidenav elements DO NOT like being broken into levels -->
@let acct = account();
<div>
    <h1>{{ acct.name }}</h1>
    @if (acct.description) {
        <p><mat-icon>description</mat-icon>{{ acct.description }}</p>
    }
    @if (acct.sfAccountId) {
        <p><mat-icon>wb_cloudy</mat-icon>SFDC: {{ acct.sfAccountId }}</p>
    }

    <p><mat-icon>fingerprint</mat-icon>Organization ID : {{ acct.id }}</p>
    <p><mat-icon>check_circle_outline</mat-icon>Created: {{ acct.createdAt | date: 'medium' }}</p>
    <p><mat-icon>history</mat-icon>Last Updated: {{ acct.updatedAt | date: 'medium' }}</p>
</div>
